import gql from "graphql-tag";

export const notionDatabase = gql`
  fragment NotionDatabase on NotionDatabase {
    id
    name
    integrationId
  }
`;
